import { ChangeDetectionStrategy, Component, OnDestroy, NgZone, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'gtd-ui-current-time',
  templateUrl: './current-time.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrentTimeComponent implements AfterViewInit, OnDestroy {
  private timerId: any;
  @ViewChild('currentTimeElement') currentTimeElement: ElementRef<HTMLDivElement>;
  public timeZone = '';

  constructor(private ngZone: NgZone) {
    this.timeZone = 'Etc/UTC';
  }

  tick = () => {
    const mdate = moment().utc();
    const date = mdate.format('DD/MM/YYYY');
    const time = mdate.format('HH:mm:ss');
    this.currentTimeElement.nativeElement.innerHTML = `<span>${date}</span><div class="c-time__dot"></div><b>${time}</b>`;
    this.ngZone.runOutsideAngular(() => {
      this.timerId = setTimeout(this.tick, 2500);
    });
  };

  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.timerId = setTimeout(this.tick);
    });
  }

  ngOnDestroy(): void {
    clearTimeout(this.timerId);
  }
}
